// extracted by mini-css-extract-plugin
module.exports = {"kitE":"kitE_kitE__TgxNU"};